(() => {
  "use strict";
  const root = () =>
      document.querySelector('.mqsm[aria-label="Lever-Type Indicators"]'),
    el = (tag, cls, text) => {
      const n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    },
    num = (v) => Number(String(v).replace(",", "."));
  function values(text, unit) {
    const source = String(text || "")
        .replace(/,/g, ".")
        .replace(/[“”]/g, '"'),
      rx =
        unit === "mm"
          ? /(0?\.\d+|\d+(?:\.\d+)?)\s*mm\b/gi
          : /(0?\.\d+|\d+(?:\.\d+)?)\s*(?:"|″)/g;
    return [...source.matchAll(rx)].map((m) => num(m[1]));
  }
  const label = (value, unit) =>
    value == null
      ? ""
      : String(value).replace(/^0\./, ".") + (unit === "mm" ? "mm" : '"');
  function range(record) {
    const sku = String(record.sku || "")
      .replace(/-/g, "")
      .toUpperCase();
    if (sku === "GT1453") return { metric: ".2mm", inch: "", end: 0.2 };
    if (sku === "GT1453A") return { metric: "", inch: '.008"', end: 0.2032 };
    if (sku === "GT1456R") return { metric: ".14mm", inch: "", end: 0.14 };
    const field = clean(record.range),
      text = field || record.title,
      mm = values(text, "mm"),
      inch = values(text, "inch");
    let metric = mm.length ? mm[mm.length - 1] : null,
      imperial = inch.length ? inch[inch.length - 1] : null;
    if (!field) {
      const explicitMM =
          text.match(
            /\brange\s*(?:0\s*(?:-|–|to|x)\s*)?(\d+(?:[.,]\d+)?)\s*mm\b/i,
          ) || text.match(/(?:x|×)\s*(\d+(?:[.,]\d+)?)\s*mm\b/i),
        explicitInch =
          text.match(
            /\brange\s*(?:0\s*(?:-|–|to|x)\s*)?(\d+(?:[.,]\d+)?)\s*(?:"|″)/i,
          ) || text.match(/(?:x|×)\s*(\d+(?:[.,]\d+)?)\s*(?:"|″)/i);
      if (explicitMM) metric = num(explicitMM[1]);
      else if (mm.length) metric = mm.find((v) => v > 0.05) ?? mm[0];
      if (explicitInch) imperial = num(explicitInch[1]);
      else if (inch.length) imperial = inch.find((v) => v > 0.002) ?? inch[0];
    }
    return {
      metric: label(metric, "mm"),
      inch: label(imperial, "inch"),
      end: metric ?? (imperial == null ? null : imperial * 25.4),
    };
  }
  function graduation(record) {
    const sku = String(record.sku || "")
      .replace(/-/g, "")
      .toUpperCase();
    if (sku === "GT1453") return { metric: ".002mm", inch: "" };
    if (sku === "GT1453A") return { metric: "", inch: '.0001"' };
    if (sku === "GT1456R") return { metric: ".001mm", inch: "" };
    const text = record.graduation || record.title,
      mm = values(text, "mm").filter((v) => v <= 0.05),
      inch = values(text, "inch").filter((v) => v <= 0.002);
    return { metric: label(mm[0], "mm"), inch: label(inch[0], "inch") };
  }
  function style(text) {
    if (/vertical/i.test(text)) return "Vertical";
    if (/parallel/i.test(text)) return "Parallel";
    if (/pocket/i.test(text)) return "Pocket";
    if (/universal/i.test(text)) return "Universal";
    if (/horizontal/i.test(text)) return "Horizontal";
    return "Standard";
  }
  function units(record) {
    if (/^513-406-10[TE]$/i.test(record.sku) || record.sku === "4307106")
      return "Inch/Metric";
    if (/^513-409-10[TE]$/i.test(record.sku)) return "Metric/Inch";
    const text = (record.graduation || record.range || "")
        .replace(/,/g, ".")
        .replace(/[“”]/g, '"'),
      metric = text.search(/\d\s*mm\b/i),
      inch = text.search(/\d\s*"/);
    if (metric >= 0 && inch >= 0)
      return inch < metric ? "Inch/Metric" : "Metric/Inch";
    if (metric >= 0) return "Metric";
    if (inch >= 0) return "Inch";
    return "";
  }
  function clean(value) {
    return String(value || "")
      .replace(/^\["?|"?\]$/g, "")
      .trim();
  }
  function instrument(record) {
    const t = (
      record.title +
      " " +
      record.type +
      " " +
      record.vendor
    ).toLowerCase();
    if (
      record.indicatorAccessory ||
      record.tags.some(
        (tag) => String(tag).toLowerCase() === "indicator-accessory",
      )
    )
      return false;
    if (/\bgirod\b/.test(t)) return true;
    if (
      /\b(?:accessor(?:y|ies)|holders?|magnetic bases?|replacement stylus|contact points?|inserts?|spares?|extension rods?|clamps?|attachments?)\b/.test(
        t,
      )
    )
      return false;
    return /\b(?:lever[- ]type|lever dial indicator|dial test indicator|test indicators?|lever indicator|martest|dti|digital test indicator|smart digital indicator)\b/.test(
      t,
    );
  }
  function classify(template) {
    let tags = [];
    try {
      tags = JSON.parse(template.dataset.tags || "[]");
    } catch (_e) {}
    const r = {
      template,
      title: template.dataset.title || "",
      vendor: template.dataset.vendor || "",
      type: template.dataset.type || "",
      sku: template.dataset.sku || "",
      price: Number(template.dataset.price || 0),
      indicatorAccessory: template.dataset.indicatorAccessory === "true",
      range: template.dataset.range || "",
      graduation: template.dataset.graduation || "",
      faceField: template.dataset.face || "",
      stylus: clean(template.dataset.stylus),
      contact: clean(template.dataset.contact),
      accuracy: clean(template.dataset.accuracy),
      scale: clean(template.dataset.scale),
      force: clean(template.dataset.force),
      tags,
    };
    const rg = range(r),
      gr = graduation(r);
    r.metricRange = rg.metric;
    r.inchRange = rg.inch;
    r.rangeEnd = rg.end;
    r.metricGraduation = gr.metric;
    r.inchGraduation = gr.inch;
    r.style = style(r.title + " " + tags.join(" "));
    r.units = units(r);
    r.readout = /\b(?:digital|electronic|smart)\b/i.test(r.title + " " + r.type)
      ? "Digital"
      : "Analogue";
    const faceText = r.faceField || r.title,
      faceMM = values(faceText, "mm"),
      faceInch = values(faceText, "inch");
    r.face = faceMM.length
      ? label(faceMM[0], "mm")
      : faceInch.length
        ? label(faceInch[0], "inch")
        : "";
    if (!r.stylus) {
      const m = r.title.match(
        /stylus (?:length\s*)?[:=]?\s*(\d+(?:[.,]\d+)?)\s*(mm|"|″)/i,
      );
      r.stylus = m
        ? label(num(m[1]), m[2].toLowerCase() === "mm" ? "mm" : "inch")
        : "";
    }
    return r;
  }
  async function load(url, page) {
    const u = new URL(url, location.origin);
    u.searchParams.set("view", "mqs-lever-data");
    u.searchParams.set("page", String(page));
    const response = await fetch(u, { credentials: "same-origin" });
    if (!response.ok) throw Error("Collection HTTP " + response.status);
    const doc = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      ),
      feed = doc.querySelector("[data-mqsl-feed]");
    if (!feed) throw Error("Lever indicator page " + page + " was incomplete");
    const localSeeds =
      page === 1 && root()
        ? [
            ...root().querySelectorAll(
              "[data-mqsl-seeds] template[data-mqsl-record]",
            ),
          ]
        : [];
    return {
      pages: Number(feed.dataset.pages),
      items: [
        ...feed.querySelectorAll("template[data-mqsl-record]"),
        ...localSeeds,
      ],
    };
  }
  async function loadBrand(brand, page = 1) {
    const u = new URL("/search", location.origin);
    u.searchParams.set("type", "product");
    u.searchParams.set("q", brand === "Girod" ? brand : brand + " indicator");
    u.searchParams.set("view", "mqs-lever-brand-data");
    u.searchParams.set("page", String(page));
    const response = await fetch(u, { credentials: "same-origin" });
    if (!response.ok) throw Error(brand + " search HTTP " + response.status);
    const doc = new DOMParser().parseFromString(
        await response.text(),
        "text/html",
      ),
      feed = doc.querySelector("[data-mqsl-brand-feed]");
    if (!feed) throw Error(brand + " catalogue search was incomplete");
    const brandRx = new RegExp(brand, "i"),
      items = [...feed.querySelectorAll("template[data-mqsl-record]")].filter(
        (t) =>
          brandRx.test(
            (t.dataset.vendor || "") + " " + (t.dataset.title || ""),
          ),
      );
    return { pages: Number(feed.dataset.pages) || 1, items };
  }
  function add(select, items, numeric = false) {
    const vals = [...new Set(items.filter(Boolean))];
    vals.sort(
      numeric
        ? (a, b) =>
            (parseFloat(a) || Infinity) - (parseFloat(b) || Infinity) ||
            a.localeCompare(b)
        : undefined,
    );
    for (const v of vals) {
      const o = el("option", "", v);
      o.value = v;
      select.append(o);
    }
  }
  async function init() {
    const host = root();
    if (!host) return;
    const status = host.querySelector("[data-mqsl-status]"),
      grid = host.querySelector("[data-mqsl-grid]"),
      count = host.querySelector("[data-mqsl-count]"),
      pager = host.querySelector("[data-mqsl-pages]"),
      sort = host.querySelector("[data-mqsl-sort]");
    try {
      const first = await load(host.dataset.mqslUrl, 1),
        batches = [first];
      if (!first.pages || first.pages > 20)
        throw Error("Unexpected collection size");
      for (let start = 2; start <= first.pages; start += 4) {
        const jobs = [];
        for (
          let page = start;
          page < Math.min(start + 4, first.pages + 1);
          page++
        )
          jobs.push(load(host.dataset.mqslUrl, page));
        batches.push(...(await Promise.all(jobs)));
      }
      const missingBrands = [
          "Insize",
          "Inspec",
          "Girod",
          "Starrett",
          "Peacock",
          "Baker",
        ],
        brandFirst = await Promise.all(missingBrands.map((b) => loadBrand(b)));
      batches.push(...brandFirst);
      const brandMore = [];
      brandFirst.forEach((batch, i) => {
        for (let page = 2; page <= Math.min(batch.pages, 10); page++)
          brandMore.push(loadBrand(missingBrands[i], page));
      });
      if (brandMore.length) batches.push(...(await Promise.all(brandMore)));
      const map = new Map();
      for (const t of batches.flatMap((b) => b.items))
        if (t.dataset.id) map.set(t.dataset.id, t);
      const records = [...map.values()].map(classify).filter(instrument);
      const controls = [...host.querySelectorAll("[data-mqsl-filter]")],
        filter = (n) => host.querySelector('[data-mqsl-filter="' + n + '"]');
      if (records.length < 20)
        throw Error("Too few lever indicators were returned");
      for (const [name, numeric] of [
        ["brand", false],
        ["style", false],
        ["metricRange", true],
        ["inchRange", true],
        ["metricGraduation", true],
        ["inchGraduation", true],
        ["face", true],
        ["stylus", true],
        ["contact", true],
        ["accuracy", true],
        ["scale", false],
        ["force", true],
      ])
        add(
          filter(name),
          records.map((r) => (name === "brand" ? r.vendor : r[name])),
          numeric,
        );
      let current = 1;
      function render() {
        const f = Object.fromEntries(
            controls.map((c) => [c.dataset.mqslFilter, c.value]),
          ),
          found = records.filter((r) =>
            Object.entries(f).every(
              ([k, v]) => !v || (k === "brand" ? r.vendor : r[k]) === v,
            ),
          );
        found.sort((a, b) =>
          sort.value === "price"
            ? (a.price || Infinity) - (b.price || Infinity) ||
              a.sku.localeCompare(b.sku, undefined, { numeric: true })
            : sort.value === "price-desc"
              ? (b.price || -1) - (a.price || -1) ||
                a.sku.localeCompare(b.sku, undefined, { numeric: true })
            : sort.value === "sku"
            ? a.sku.localeCompare(b.sku, undefined, { numeric: true })
            : sort.value === "brand"
              ? a.vendor.localeCompare(b.vendor) ||
                a.sku.localeCompare(b.sku, undefined, { numeric: true })
              : sort.value === "range-desc"
                ? (b.rangeEnd ?? -1) - (a.rangeEnd ?? -1)
                : (a.rangeEnd ?? Infinity) - (b.rangeEnd ?? Infinity) ||
                  a.sku.localeCompare(b.sku, undefined, { numeric: true }),
        );
        const pages = Math.max(1, Math.ceil(found.length / 48));
        current = Math.min(current, pages);
        const start = (current - 1) * 48,
          frag = document.createDocumentFragment();
        for (const r of found.slice(start, start + 48))
          frag.append(r.template.content.cloneNode(true));
        grid.replaceChildren(frag);
        count.textContent =
          found.length +
          " matching lever indicators" +
          (found.length
            ? " · showing " +
              (start + 1) +
              "–" +
              Math.min(start + 48, found.length)
            : "");
        pager.replaceChildren();
        if (pages > 1)
          for (const [name, page] of [
            ["Previous", current - 1],
            ["Page " + current + " of " + pages, current],
            ["Next", current + 1],
          ]) {
            if (page < 1 || page > pages) continue;
            const b = el("button", "", name);
            b.type = "button";
            b.disabled = page === current;
            b.addEventListener("click", () => {
              current = page;
              render();
              grid.scrollIntoView({ behavior: "smooth" });
            });
            pager.append(b);
          }
      }
      controls.forEach((c) =>
        c.addEventListener("change", () => {
          current = 1;
          render();
        }),
      );
      sort.addEventListener("change", () => {
        current = 1;
        render();
      });
      host.querySelector("[data-mqsl-clear]").addEventListener("click", () => {
        controls.forEach((c) => (c.value = ""));
        sort.value = "range";
        current = 1;
        render();
      });
      host.querySelector("[data-mqsl-filters]").hidden = false;
      host.querySelector("[data-mqsl-sort-wrap]").hidden = false;
      status.textContent =
        "Choose filters to narrow the Lever-Type Indicators collection.";
      render();
    } catch (error) {
      status.textContent =
        "Lever indicator filters could not load: " +
        error.message +
        ". Please retry this page.";
      count.textContent = "Lever indicators could not load.";
    }
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
